import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './custom-style.css';
// 🎯 MIXPANEL SETUP WITH ENHANCED FEATURES
import mixpanelTracking from './utils/mixpanelTracking';
import mixpanelScreenRecording from './utils/mixpanelScreenRecording';

// Initialize Mixpanel once with all features
mixpanelTracking.init();
mixpanelTracking.setupAutoTracking();

// Force disable autocapture to prevent [Auto] Element Click events
setTimeout(() => {
  mixpanelTracking.forceDisableAutocapture();
}, 500);

// Disabled to prevent autocapture events
// mixpanelTracking.startSessionRecording();
// mixpanelTracking.enableHeatmapTracking();

// Initialize screen recording with settings aligned to Mixpanel's native configuration
mixpanelScreenRecording.initScreenRecording({
  captureRate: 0.5, // Lower capture rate to reduce overhead
  quality: 0.5,
  maxDuration: 600, // 10 minutes max
  recordConsole: true,
  recordNetwork: true,
  maskSensitiveElements: true,
  // These settings align with Mixpanel's native configuration
  useNativeRecordingWhenAvailable: true
});

// Create dark black theme
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ff5b8d', // Pink accent
    },
    secondary: {
      main: '#7952f6', // Secondary color (optional)
    },
    background: {
      default: '#0a0a0a', // Very dark gray (almost black) main background
      paper: '#1c1c1c',   // Dark gray for sidebar/app bar
    },
    info: {
      main: '#5be5ff',
    },
    success: {
      main: '#4caf50',
    },
    warning: {
      main: '#ff9800',
    },
    error: {
      main: '#f44336',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1c1c1c',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1c1c1c',
          borderRight: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#262626', // Darker gray for cards
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '6px',
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);